<template>
  <layout-main-inner
    title="题库管理"
    class="flex-1">
    <div slot="action">
      <el-dropdown>
        <el-button
          type="primary">
          新增试题<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in questionType"
            :key="item.value"
            @click.native="additem(item.value)">{{ item.label }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap hasSlot>
      <el-form
        slot="form"
        class="form-item-mt0"
        style="flex: 1"
        label-width="90px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="考试科目：">
              <subject-select
                v-model="config.subjectId"
                showAll />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试题题型：">
              <question-type-select v-model="config.questionType" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试题难度：">
              <question-difficulty-select v-model="config.questionDifficulty" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试题题干：">
              <el-input
                v-model="config.questionName"
                clearable
                placeholder="请输入题干"
                @clear="handleCurrentChange(1)">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="handleCurrentChange(1)"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="考试科目"
          min-width="100"
          prop="subjectName"></el-table-column>
        <el-table-column
          label="题型"
          min-width="80"
          prop="questionType">
          <template slot-scope="{ row }">{{ row.questionType | questionTypeName() }}</template>
        </el-table-column>
        <el-table-column
          label="题干"
          min-width="400"
          prop="questionName">
        </el-table-column>
        <el-table-column
          label="难度"
          min-width="100"
          prop="orgName">
          <template slot-scope="{ row }">
            <el-rate
              v-model="row.questionDifficulty"
              :max="3"
              disabled
              show-text
              :texts="texts"></el-rate>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          min-width="80"
          prop="status">
          <template slot-scope="{ row }">{{ row.status | questionStatusName() }}</template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="130">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-button
              type="text"
              @click="deleteitem(row)">删除</el-button>
            <el-button
              type="text"
              @click="previewitem(row)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
    <examination-question-modal
      ref="question"
      :callback="getlist" />
    <question-preview-modal ref="preview" />
  </layout-main-inner>
</template>
<script>
import ExaminationQuestionModal from './busi/examination-question-modal.vue'
import { difficultyTexts, questionType } from '../index'
import SubjectSelect from '../subject-select.vue'
import QuestionTypeSelect from '../question-type-select.vue'
import QuestionDifficultySelect from '../question-difficulty-select.vue'
import QuestionPreviewModal from './busi/question-preview-modal.vue'
export default {
  name: 'ExaminationQuestionList',
  components: { ExaminationQuestionModal, SubjectSelect, QuestionTypeSelect, QuestionDifficultySelect, QuestionPreviewModal },
  data() {
    return {
      loading: true,
      texts: difficultyTexts,
      questionType,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, subjectId: null, questionType: null, questionDifficulty: null, questionName: '' }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    previewitem(row) {
      const { choices, questionName, questionContentImages } = row
      this.$refs.preview.init({ choices, questionName, questionContentImages: questionContentImages ? questionContentImages.split(',') : [] })
    },
    additem(questionType) {
      this.$refs.question.init({ questionType })
    },
    updateitem(row) {
      const { id, subjectId, questionName, questionContentImages, questionType, questionDifficulty, status, subjectName, choices } = row // choiceType: 1, answer: null,
      const choice = choices[0]
      const answer = choices.find(i => i.isAnswer === 1).label
      const choicesFormatter = choices.map(i => {
        const { label, labelDisplay, content, contentInputType } = i
        return { label, labelDisplay, content: contentInputType === 1 ? content : '', contentImage: contentInputType === 2 ? this.$splitImage(content) : [] }
      })
      this.$refs.question.init({
        id, subjectId, questionName, questionType, questionDifficulty, status, subjectName,
        choiceType: choice.contentInputType, answer, questionContentImages: this.$splitImage(questionContentImages), choices: choicesFormatter
      })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该试题?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.deleteexamquestion({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$examApi.getexamquestions(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
